import React from 'react'
import Card from '../UI/Card';
import classes from '../Users/UserList.module.css'

const UserList = props =>{
    return (
       <Card classeName = {classes.users}>
        <ul>
            {props.users.map((user)=>(
                <li key={user.id}>
                    Name is :{user.name} and Age :{user.age}
                </li>
            ))}
        </ul>
       </Card>
    )
}

export default UserList;